import script from "./BikeIllustration.vue?vue&type=script&setup=true&lang=ts"
export * from "./BikeIllustration.vue?vue&type=script&setup=true&lang=ts"

import "./BikeIllustration.vue?vue&type=style&index=0&id=ce398dc6&lang=scss"

const __exports__ = script;

export default __exports__